import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import {
  CreateJustificationDocTypeParams,
  JustificationDocType,
  ListJustificationDocTypeRequestParams,
  UpdateJustificationDocTypeParams
} from '~core/models/justification-doc-type.models';

@Injectable()
export class JustificationDocTypeService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    beneficiaryCategoryId: string,
    params?: ListJustificationDocTypeRequestParams
  ): Observable<Pagination<JustificationDocType>> {
    return this._http.get<Pagination<JustificationDocType>>(
      `${this._apiConstantsService.beneficiaryCategoryUrl}/${beneficiaryCategoryId}/justification-doc-types`,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(
    beneficiaryCategoryId: string,
    id: string
  ): Observable<JustificationDocType> {
    return this._http.get<JustificationDocType>(
      `${this._apiConstantsService.beneficiaryCategoryUrl}/${beneficiaryCategoryId}/justification-doc-types/${id}`
    );
  }

  create(
    beneficiaryCategoryId: string,
    payload: CreateJustificationDocTypeParams
  ): Observable<JustificationDocType> {
    return this._http.post<JustificationDocType>(
      `${this._apiConstantsService.beneficiaryCategoryUrl}/${beneficiaryCategoryId}/justification-doc-types`,
      payload
    );
  }

  update(
    beneficiaryCategoryId: string,
    id: string,
    payload: UpdateJustificationDocTypeParams
  ): Observable<JustificationDocType> {
    return this._http.patch<JustificationDocType>(
      `${this._apiConstantsService.beneficiaryCategoryUrl}/${beneficiaryCategoryId}/justification-doc-types/${id}`,
      payload
    );
  }

  delete(beneficiaryCategoryId: string, id: string): Observable<unknown> {
    return this._http.delete(
      `${this._apiConstantsService.beneficiaryCategoryUrl}/${beneficiaryCategoryId}/justification-doc-types/${id}`
    );
  }
}
